import { render, staticRenderFns } from "./link-modal.vue?vue&type=template&id=2d8b9cc8&scoped=true"
import script from "./link-modal.vue?vue&type=script&lang=js"
export * from "./link-modal.vue?vue&type=script&lang=js"
import style0 from "./link-modal.vue?vue&type=style&index=0&id=2d8b9cc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d8b9cc8",
  null
  
)

export default component.exports